// extracted by css-extract-rspack-plugin
export default {"formContainer":"form-container--Uf1M94fZMO81aRwy","formContentContainer":"form-content-container--Y3u2iBnnl0ItmvqW","footer":"footer--fG78MVBQiosbbrCl"};